import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { ColorId, HatBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-------------------------------------------------------------------------
const colorMap: { [key in ColorId]: string } = {
  all: 'hat/block.hat.all.png',
  blue: 'hat/block.hat.blue.png',
  green: 'hat/block.hat.green.png',
  purple: 'hat/block.hat.purple.png',
  red: 'hat/block.hat.red.png',
  yellow: 'hat/block.hat.yellow.png',
};

/*
    hat block view
*/
export class HatBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: HatBlockProps) {
    // create base view
    super();

    this.addChild(new FitWidthBlockSprite(colorMap[props.color], props));
    blockPositionView(this, props);
  }

  public static assets(props: HatBlockProps) {
    return [
      colorMap[props.color],
      {
        url: getMatch2AssetPath('fx.hat'),
        loadMethod: MovieClip.animationLoader,
      },
    ];
  }
}
